const de = {
  meta: {
    title: "Nexora Technologies — Der europäische Partner für KI-Transformation",
  },
  nav: {
    home: "Start",
    services: "Leistungen",
    aiTransformation: "KI-Transformation",
    industries: "Branchen",
    about: "Über uns",
    contact: "Kontakt",
    countries: "Länder",
    bookStrategy: "Strategiegespräch buchen",
  },
  countriesNav: {
    netherlands: "Niederlande",
    germany: "Deutschland",
    switzerland: "Schweiz",
    belgium: "Belgien",
    "united-kingdom": "Vereinigtes Königreich",
  },
  langSwitcher: { label: "Sprache" },
  hero: {
    eyebrow: "Der europäische Partner für KI-Transformation",
    title1: "Schneller skalieren.",
    title2: "Zugang zu Technologietalenten der Weltklasse.",
    subtitle:
      "Nexora Technologies hilft europäischen Organisationen, Engpässe bei Technologietalenten durch Nearshore-Delivery und KI-Transformation zu beheben.",
    bookDiscovery: "Erstgespräch vereinbaren",
    requestTalent: "Technologietalent anfragen",
  },
  trustStats: [
    { value: "20+", label: "Jahre internationale Delivery" },
    { value: "5", label: "Europäische Märkte bedient" },
    { value: "500+", label: "Eingesetzte Spezialisten" },
    { value: "<1h", label: "Durchschnittliche Reaktionszeit" },
  ],
  whyUs: {
    eyebrow: "warum nexora",
    title: "Technologie entwickelt sich schneller, als Organisationen einstellen können.",
    lede:
      "Erfahrene KI-Engineers, Cloud-Architekten, SAP-Berater und Cybersecurity-Spezialisten zu finden, ist eine der größten Herausforderungen in ganz Europa geworden.",
    body1:
      "Nexora verschafft Organisationen sofortigen Zugang zu hochqualifizierten Technologiefachkräften über ein flexibles Nearshore-Delivery-Modell mit minimalem Zeitunterschied — für eine nahtlose Zusammenarbeit mit internen Teams.",
    body2:
      "Seit mehr als 20 Jahren liefern wir erfolgreiche Outsourcing-, Insourcing- und digitale Transformationsprogramme für internationale Kunden.",
    aboutLink: "Über Nexora",
    deliverablesEyebrow: "was wir liefern",
  },
  deliverables: [
    "KI-Engineers",
    "Generative-KI-Spezialisten",
    "Machine-Learning-Engineers",
    "Cloud-Engineers",
    "Cybersecurity-Experten",
    "DevOps-Engineers",
    "Data-Engineers",
    "SAP-Berater",
    "Software-Entwicklungsteams",
    "Technology Transformation Consulting",
  ],
  servicesSection: {
    eyebrow: "leistungen",
    title: "Eine Enterprise-Plattform an Fähigkeiten — geliefert als Einheit.",
    lede:
      "Von KI-Kompetenzzentren bis zu dedizierten Nearshore-Engineering-Pods: Unsere Leistungen verbinden sich, um Ihre technologische Umsetzung zu skalieren.",
  },
  services: [
    {
      slug: "ai-transformation",
      title: "KI-Transformation",
      summary:
        "Identifizieren, gestalten und operationalisieren Sie KI-Use-Cases mit messbarem Geschäftswert — von der Strategie bis zum Rollout.",
      bullets: ["KI-Strategie & Roadmap", "Generative-KI-Lösungen", "KI-Governance", "AI Centre of Excellence"],
    },
    {
      slug: "dedicated-teams",
      title: "Dedizierte Engineering-Teams",
      summary:
        "Senior-Nearshore-Engineering-Pods, die direkt in Ihre Delivery passen — gleiche Zeitzone, europäische Standards.",
      bullets: ["Pod-basierte Delivery", "Senior-geführte Teams", "Transparente Governance", "Flexibel skalierbar"],
    },
    {
      slug: "cloud",
      title: "Cloud-Engineering",
      summary:
        "Azure-, AWS- und GCP-Architektur, Migration und FinOps — gebaut für europäische Compliance und Resilienz.",
      bullets: ["Landing Zones", "Cloud-Migration", "Plattform-Engineering", "FinOps"],
    },
    {
      slug: "cybersecurity",
      title: "Cybersecurity",
      summary: "Von Zero-Trust-Architektur bis OT-Security — schützen Sie Ihr Unternehmen auf jeder Ebene.",
      bullets: ["Zero-Trust-Design", "Cloud-Security", "Identity & Access", "OT / IoT-Security"],
    },
    {
      slug: "sap",
      title: "SAP & Enterprise-Plattformen",
      summary:
        "S/4HANA, BTP und Enterprise-Modernisierungsprogramme, geliefert von zertifizierten Senior-Beratern.",
      bullets: ["S/4HANA-Migration", "BTP-Entwicklung", "Integration", "Managed Services"],
    },
    {
      slug: "software-engineering",
      title: "Software-Engineering",
      summary:
        "Vollständiges Produkt-Engineering — Discovery, Design, Build und Modernisierung — mit europäischer Qualität.",
      bullets: ["Produkt-Engineering", "Plattform-Modernisierung", "QA & DevOps", "API-Plattformen"],
    },
  ],
  countriesSection: {
    eyebrow: "unsere märkte",
    title: "Gebaut für europäische Delivery.",
    lede:
      "Senior-geführte Pods in Ihrer Zeitzone, mit lokalem Marktwissen in fünf europäischen Kernländern.",
    exploreLabel: "Entdecken",
  },
  aiFeature: {
    eyebrow: "ki-transformation",
    title: "Künstliche Intelligenz ist keine Zukunftsinitiative mehr.",
    lede:
      "Sie ist zur Wettbewerbsnotwendigkeit geworden. Nexora hilft Organisationen, KI-Lösungen zu identifizieren, zu gestalten und umzusetzen, die messbaren Geschäftswert schaffen.",
    tags: ["KI-Strategie", "Generative KI", "KI-Governance", "AI Centre of Excellence"],
    exploreLink: "KI-Transformationsleistungen entdecken",
  },
  principles: {
    eyebrow: "wie wir arbeiten",
    title: "Gebaut für europäische Unternehmen.",
    lede:
      "Unser Delivery-Modell ist auf Transparenz, Governance und Senior-geführte Ergebnisse ausgelegt.",
    items: [
      {
        title: "Senior-geführte Projekte",
        desc:
          "Jedes Programm wird von Senior-Engineers und Beratern geführt — keine Junior-Ressourcen hinter einer Marke.",
      },
      {
        title: "Europäische Standards",
        desc:
          "DSGVO-konforme Delivery, EU-AI-Act-konforme Governance und ein Nearshore-Modell zu denselben Geschäftszeiten.",
      },
      {
        title: "Ergebnis statt Stunden",
        desc:
          "Wir verpflichten uns auf messbare Ergebnisse, nicht auf Stundenzettel. Unsere Pods sind End-to-End verantwortlich.",
      },
      {
        title: "Transparente Governance",
        desc:
          "Offene Delivery-Dashboards, wöchentliche Steuerungsrituale, volle Sicht auf Velocity und Risiko.",
      },
    ],
  },
  finalCta: {
    eyebrow: "nächster schritt",
    heading: "Bauen wir Ihren Wettbewerbsvorteil auf.",
    lede:
      "Sprechen Sie mit einem Senior-Strategen von Nexora. In einem Gespräch identifizieren wir die wirkungsstärksten Technologie- und KI-Schritte für Ihre Organisation.",
    button: "Strategiegespräch buchen",
    exploreBtn: "Unsere Leistungen entdecken",
  },
  leadForm: {
    stepLabels: ["Land", "Skills", "Teamgröße", "Dauer", "Ihre Daten"],
    country: { title: "Welches Land?", lede: "Wählen Sie, wo Sie Senior-Technologietalent benötigen." },
    skills: {
      title: "Welche Skills suchen Sie?",
      lede: "Wählen Sie alles Zutreffende. Sie können Spezialisten mischen oder ein komplettes Team beschreiben.",
    },
    teamSize: {
      title: "Wie groß soll das Team sein?",
      lede: "Wir skalieren von einem einzelnen Senior-Spezialisten bis zu einem vollständigen Pod.",
    },
    duration: {
      title: "Wie lange läuft das Engagement?",
      lede: "Die meisten Engagements starten mit 3 Monaten und werden ergebnisbasiert verlängert.",
    },
    details: {
      title: "Ihre Daten",
      lede: "Wir leiten Ihre Anfrage an den passenden Senior-Strategen weiter.",
      name: "Vollständiger Name",
      email: "Geschäftliche E-Mail",
      company: "Unternehmen",
      message: "Was möchten Sie erreichen? (optional)",
      namePh: "Jana Bergmann",
      emailPh: "jana@firma.eu",
      companyPh: "Ihre Organisation",
      messagePh: "Beschreiben Sie kurz Ihre Initiative, Zeitpläne und mögliche Einschränkungen.",
    },
    back: "Zurück",
    next: "Weiter",
    send: "Anfrage senden",
    sending: "Senden…",
    successTitle: "Anfrage erhalten.",
    successLede:
      "Vielen Dank. Ein Senior-Stratege von Nexora meldet sich innerhalb eines Werktages, um Ihr Erstgespräch zu vereinbaren.",
    errorGeneric: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
    toastSuccessTitle: "Anfrage erhalten",
    toastSuccessDesc: "Ein Nexora-Stratege meldet sich innerhalb eines Werktages.",
    toastErrorTitle: "Senden fehlgeschlagen",
  },
  skills: {
    "ai-engineers": "KI-Engineers",
    "generative-ai": "Generative-KI-Spezialisten",
    "ml-engineers": "Machine-Learning-Engineers",
    mlops: "MLOps-Engineers",
    "data-engineers": "Data-Engineers",
    "data-scientists": "Data Scientists",
    "cloud-engineers": "Cloud-Engineers (Azure / AWS / GCP)",
    "cloud-architects": "Cloud-Architekten",
    devops: "DevOps-Engineers",
    cybersecurity: "Cybersecurity-Spezialisten",
    sap: "SAP-Berater",
    "software-dev": "Software-Entwicklungsteams",
    java: "Java-Entwickler",
    dotnet: ".NET-Entwickler",
    python: "Python-Entwickler",
    fullstack: "Fullstack-Entwickler",
    "power-platform": "Microsoft Power Platform",
    salesforce: "Salesforce-Berater",
    transformation: "Technology Transformation Consulting",
  },
  teamSizes: {
    "1-3": "1 – 3 Spezialisten",
    "4-6": "4 – 6 Spezialisten",
    "7-10": "7 – 10 Spezialisten",
    "10-plus": "10+ Spezialisten",
  },
  durations: {
    "3m": "3 Monate",
    "6m": "6 Monate",
    "12m": "12 Monate",
    ongoing: "Laufende Partnerschaft",
  },
  contactPage: {
    eyebrow: "Strategiegespräch buchen",
    title1: "Bauen wir Ihren",
    title2: "Wettbewerbsvorteil auf.",
    lede:
      "Erzählen Sie uns von der Technologietalent- oder KI-Transformationsinitiative, die Sie planen. Ein Senior-Stratege von Nexora meldet sich innerhalb eines Werktages.",
    directHeading: "direkt",
    addressList: "Amsterdam · Frankfurt · Zürich · Brüssel · London",
    whatToExpectHeading: "was Sie erwartet",
    whatToExpectList: [
      "Antwort innerhalb eines Werktages",
      "Erstgespräch mit einem Senior-Strategen",
      "Maßgeschneiderter Vorschlag in <5 Tagen",
      "Keine Verpflichtung, volle Vertraulichkeit",
    ],
  },
  aboutPage: {
    eyebrow: "Über uns",
    title1: "Der europäische Partner",
    title2: "für KI-Transformation.",
    lede:
      "Nexora Technologies hilft europäischen Organisationen, Technologiekapazitäten durch KI-Transformation, knappes Technologietalent und dedizierte Nearshore-Engineering-Teams zu skalieren.",
    missionEyebrow: "unsere mission",
    missionTitle: "Europäische Unternehmen im KI-Zeitalter wettbewerbsfähig zu machen.",
    missionPara1:
      "Seit mehr als 20 Jahren liefern wir Outsourcing-, Insourcing- und digitale Transformationsprogramme für internationale Kunden. Heute fokussieren wir uns auf eine Mission: Europäische Organisationen im KI-Zeitalter gewinnen zu lassen.",
    missionPara2:
      "Wir verbinden knappes Technologietalent, ein governed Nearshore-Delivery-Modell und tiefe KI-Expertise, um unseren Kunden die Umsetzungsgeschwindigkeit zu geben, die moderne Konkurrenz fordert.",
    missionList: [
      "Vertraut von internationalen Enterprises in fünf europäischen Kernmärkten",
      "Senior-geführte Pods — keine Junior-Ressourcen hinter einer Marke",
      "Ergebnisbasierte Engagements mit transparenter Governance",
      "AI-native Delivery, DSGVO-native by design",
    ],
  },
  servicesPage: {
    eyebrow: "Leistungen",
    title1: "Eine Enterprise-Plattform",
    title2: "an Technologiekapazität.",
    lede:
      "Sechs miteinander verbundene Leistungen — vereint in einem governed Delivery-Modell, das Technologieumsetzung für europäische Unternehmen skaliert.",
    talkLink: "Mit Berater sprechen",
  },
  industriesPage: {
    eyebrow: "Branchen",
    title1: "Gebaut für die Branchen,",
    title2: "in denen Technologie über den Sieg entscheidet.",
    lede:
      "Branchenspezifische Delivery-Teams, die die Dynamik, Regulierung und Wettbewerbsrealität Ihrer Branche verstehen.",
    talkLink: "Sprechen Sie uns an",
  },
  industries: [
    { slug: "financial-services", title: "Finanzdienstleistungen", desc: "Banken, Versicherungen und Kapitalmärkte." },
    { slug: "government", title: "Verwaltung & öffentlicher Sektor", desc: "Digitale Verwaltung und souveräne Cloud." },
    { slug: "healthcare", title: "Healthcare & Life Sciences", desc: "Klinische, Forschungs- und Pharma-Transformation." },
    { slug: "energy", title: "Energie & Versorger", desc: "Energiewende, intelligente Netze, OT-Security." },
    { slug: "manufacturing", title: "Industrie", desc: "Industrie 4.0, Smart Factories, Supply-Chain-KI." },
    { slug: "retail", title: "Handel & E-Commerce", desc: "Omnichannel, Personalisierung und Demand-KI." },
    { slug: "logistics", title: "Logistik & Transport", desc: "Netze, Routing-Intelligenz und Digital Twins." },
    { slug: "telecom", title: "Telekommunikation", desc: "Netzmodernisierung und Customer-KI." },
  ],
  aiPage: {
    eyebrow: "KI-Transformation",
    title1: "Künstliche Intelligenz",
    title2: "ist keine Zukunftsinitiative mehr.",
    lede:
      "Sie ist zur Wettbewerbsnotwendigkeit geworden. Nexora Technologies hilft Organisationen, KI-Lösungen zu identifizieren, zu gestalten und umzusetzen, die messbaren Geschäftswert schaffen.",
    startBtn: "KI-Readiness-Assessment starten",
    allServicesBtn: "Alle Leistungen ansehen",
    servicesEyebrow: "KI-Leistungen",
    servicesTitle: "Eine vollständige KI-Delivery-Capability.",
    servicesLede:
      "Von Beratung und Governance bis Engineering und Operations — Nexora liefert KI als managed, accountable Capability.",
    approachEyebrow: "unser ansatz",
    approachTitle: "Von der Strategie zur Skalierung in vier governed Phasen.",
    approachLede:
      "Nexora bringt KI von der Ambition zu Enterprise-Grade-Ergebnissen — ohne den üblichen PoC-Friedhof.",
    talkLink: "Mit KI-Berater sprechen",
    services: [
      { title: "KI-Strategie", desc: "Definieren Sie die wertstärksten KI-Initiativen im Einklang mit Ihrer Strategie." },
      { title: "KI-Readiness-Assessment", desc: "Bewerten Sie Daten, Talent, Infrastruktur und Governance-Reife." },
      { title: "KI-Governance", desc: "Betreiben Sie KI verantwortlich mit Richtlinien, Kontrollen und EU-AI-Act-Konformität." },
      { title: "AI Factory Advisory", desc: "Entwerfen Sie ein wiederholbares Delivery-Modell, das KI von PoC zu Produktion skaliert." },
      { title: "Generative-KI-Lösungen", desc: "Bauen Sie Copilots, Agenten und Wissenssysteme auf Ihren Unternehmensdaten." },
      { title: "KI-Automatisierung", desc: "Automatisieren Sie komplexe Workflows durch LLMs, RPA und Prozessintelligenz." },
      { title: "KI-Integration", desc: "Integrieren Sie KI in Ihre Kernsysteme — CRM, ERP, Datenplattformen und mehr." },
      { title: "KI-Infrastrukturberatung", desc: "Architektur für GPU-, MLOps- und Plattformfundament für KI in Produktion." },
      { title: "KI-Schulung", desc: "Upskillen Sie Führungskräfte und Engineers mit rollenbasierten KI-Programmen." },
      { title: "AI Centre of Excellence", desc: "Bauen Sie ein CoE auf, das KI-Wertschöpfung im gesamten Unternehmen orchestriert." },
    ],
    phases: [
      { step: "01", title: "Diagnose", desc: "KI-Readiness, Wertkarte und Governance-Baseline." },
      { step: "02", title: "Design", desc: "Lösungsarchitektur, Datenfundament, Target Operating Model." },
      { step: "03", title: "Delivery", desc: "Bauen, integrieren und operationalisieren mit Senior-geführten Pods." },
      { step: "04", title: "Skalierung", desc: "AI CoE, MLOps, Modell-Lifecycle und Value Tracking." },
    ],
  },
  notFound: {
    eyebrow: "404",
    title: "Seite nicht gefunden.",
    body: "Die gesuchte Seite existiert nicht — aber wir würden uns trotzdem freuen, mit Ihnen zu sprechen.",
    backBtn: "Zurück zur Startseite",
  },
  country: {
    common: {
      specialistsEyebrow: "meistgesucht",
      specialistsTitle: "Meistgesuchte Spezialisten",
      specialistsLede:
        "Rollen, in denen die Nachfrage das Angebot übersteigt — und in denen Nexora am schnellsten liefert.",
      industriesEyebrow: "branchen",
      industriesTitle: "Branchen, die wir bedienen",
      whyEyebrow: "warum nexora",
      whyTitle: "Warum Teams sich für Nexora entscheiden",
      formEyebrow: "talent anfragen",
      formTitle: "Bauen wir Ihren Wettbewerbsvorteil auf.",
      formLede:
        "Sagen Sie uns, welche Profile Sie suchen — wir melden uns innerhalb eines Werktages.",
      formCta: "Technologietalent anfragen",
      exploreLabel: "Leistungen entdecken",
      finalHeading: "Bauen wir Ihren Wettbewerbsvorteil auf.",
      finalCta: "Strategiegespräch buchen",
      bullets: [
        "Senior-geführte Teams · Nearshore-Delivery",
        "Europäische Qualität, DSGVO-native",
        "Schnelles Onboarding · flexibel skalierbar",
      ],
    },
    netherlands: {
      eyebrow: "Niederlande",
      title: "Technologietalent für die Niederlande",
      lede:
        "Der niederländische Technologiemarkt wächst schneller als das verfügbare Talent. Wir helfen Organisationen, ihre Technologieteams schnell zu skalieren — mit erfahrenen Profis in nahezu derselben Zeitzone.",
      body:
        "Ob KI-Lösungen, Azure-Migration, SAP-Modernisierung oder Cybersecurity — wir liefern die richtigen Spezialisten genau dann, wenn Sie sie brauchen.",
      specialists: [
        "KI-Engineers",
        "Azure-Cloud-Engineers",
        "Cybersecurity-Spezialisten",
        "DevOps-Engineers",
        "Data-Engineers",
        "Microsoft-Power-Platform-Spezialisten",
        "SAP-Berater",
        "Java-Entwickler",
        "Fullstack-Entwickler",
        "Data-Analysten",
      ],
      industries: ["Finanzdienstleistungen", "Verwaltung", "Healthcare", "Energie", "Logistik", "Handel", "Industrie"],
      whyUs: [
        "Nearshore-Zusammenarbeit",
        "Minimaler Zeitunterschied",
        "Schnelles Onboarding",
        "Dedizierte Teams",
        "Flexibel skalierbar",
        "20+ Jahre internationale Delivery-Erfahrung",
      ],
    },
    germany: {
      eyebrow: "Deutschland",
      title: "IT-Spezialisten für den deutschen Markt",
      lede:
        "Der Fachkräftemangel muss Ihr Wachstum nicht bremsen. Unsere Nearshore-Teams integrieren sich nahtlos in Ihre Organisation und liefern höchste Qualität.",
      body:
        "Ob KI, Cloud-Migration, SAP-Modernisierung oder Cybersecurity — wir liefern die richtigen Expertinnen und Experten genau dann, wenn Sie sie benötigen.",
      specialists: [
        "SAP-S/4HANA-Berater",
        "KI-Engineers",
        "Cybersecurity-Spezialisten",
        "Cloud-Architekten",
        "DevOps-Engineers",
        "Embedded-Software-Engineers",
        "Data-Engineers",
        "Java-Entwickler",
        "Platform-Engineers",
        "OT-Security-Spezialisten",
      ],
      industries: ["Automotive", "Industrie", "Finanzwesen", "Healthcare", "Energie", "Verwaltung"],
      whyUs: [
        "Nearshore-Zusammenarbeit",
        "Minimaler Zeitunterschied",
        "Schnelles Onboarding",
        "Dedizierte Teams",
        "Flexible Skalierung",
        "20+ Jahre internationale Erfahrung",
      ],
    },
    switzerland: {
      eyebrow: "Schweiz",
      title: "Technologische Exzellenz für die Schweiz",
      lede:
        "Schweizer Organisationen verlangen Technologiekompetenz auf Weltklasseniveau. Unsere Spezialisten liefern Enterprise-Grade-Lösungen bei nahezu identischen Geschäftszeiten.",
      body:
        "Von Private Banking bis pharmazeutischer F&E — wir liefern die Senior-Technologen, auf die Schweizer Unternehmen vertrauen.",
      specialists: [
        "KI-Engineers",
        "Quant-Entwickler",
        "Cloud-Security-Engineers",
        "Cybersecurity-Spezialisten",
        "Azure-Architekten",
        "DevSecOps-Engineers",
        "Data-Engineers",
        "MLOps-Engineers",
        "Software-Architekten",
        "Blockchain-Engineers",
      ],
      industries: ["Banking", "Versicherung", "Life Sciences", "Pharma", "Healthcare", "Industrie"],
      whyUs: [
        "Senior-geführte Teams",
        "Schweizer Qualität",
        "Zusammenarbeit am selben Tag",
        "Souveräne Datenverarbeitung",
        "Erfahrung in regulierten Branchen",
        "20+ Jahre internationale Delivery-Erfahrung",
      ],
    },
    belgium: {
      eyebrow: "Belgien",
      title: "Technologietalent, das Innovation beschleunigt",
      lede:
        "Erfahrene IT-Profis zu finden, war noch nie schwieriger. Unsere Nearshore-Teams bieten sofortige Kapazität bei europäischen Qualitätsstandards.",
      body:
        "Von den europäischen Institutionen in Brüssel bis Finanzdienstleistungen und Life Sciences — Nexora liefert in Belgiens anspruchsvollsten Sektoren.",
      specialists: [
        "Azure-Engineers",
        "SAP-Berater",
        "Cybersecurity-Spezialisten",
        "Data-Engineers",
        "Java-Entwickler",
        ".NET-Entwickler",
        "DevOps-Engineers",
        "KI-Engineers",
        "Business-Intelligence-Spezialisten",
        "Cloud-Operations-Engineers",
      ],
      industries: ["Europäische Institutionen", "Finanzdienstleistungen", "Chemie", "Logistik", "Healthcare", "Verwaltung"],
      whyUs: [
        "Zweisprachige Zusammenarbeit",
        "EU-konform",
        "Senior-Delivery-Teams",
        "Flexible Skalierung",
        "Fokus Brüssel & Antwerpen",
        "20+ Jahre internationale Delivery-Erfahrung",
      ],
    },
    "united-kingdom": {
      eyebrow: "Vereinigtes Königreich",
      title: "Technologietalent der Weltklasse für britische Organisationen",
      lede:
        "Skalieren Sie schneller mit hocherfahrenen Technologie-Spezialisten. Wir liefern dedizierte Engineering-Teams mit minimalem Zeitunterschied und nahtloser Zusammenarbeit.",
      body:
        "Von FinTech in London bis Verteidigungs- und Energieprogrammen im ganzen Land — Nexora liefert Senior-geführte Teams auf britischem Qualitätsniveau.",
      specialists: [
        "KI-Engineers",
        "Cybersecurity-Spezialisten",
        "Cloud-Engineers",
        "DevOps-Engineers",
        "Data Scientists",
        "Python-Entwickler",
        "Java-Entwickler",
        "Salesforce-Berater",
        "AWS-Architekten",
        "Platform-Engineers",
      ],
      industries: ["Finanzdienstleistungen", "FinTech", "Healthcare", "Handel", "Verteidigung", "Energie", "Telekommunikation"],
      whyUs: [
        "Zusammenarbeit am selben Tag",
        "Senior-geführte Pods",
        "Britische Qualitätsstandards",
        "Schnelles Onboarding",
        "Flexible Skalierung",
        "20+ Jahre internationale Delivery-Erfahrung",
      ],
    },
  },
  footer: {
    tagline:
      "Der europäische Partner für KI-Transformation. Wir helfen europäischen Organisationen, Technologiekapazität durch KI-Transformation, knappes Technologietalent und dedizierte Nearshore-Engineering-Teams zu skalieren.",
    company: "Unternehmen",
    servicesCol: "Leistungen",
    countriesCol: "Länder",
    about: "Über uns",
    whyNexora: "Warum Nexora",
    contact: "Kontakt",
    aiTransformation: "KI-Transformation",
    servicesOverview: "Leistungsübersicht",
    industries: "Branchen",
    privacy: "Datenschutz",
    terms: "AGB",
    cookies: "Cookies",
    copyright: "Alle Rechte vorbehalten.",
    address: "Amsterdam · Frankfurt · Zürich · Brüssel · London",
  },
  brandTagline: "Der europäische Partner für KI-Transformation",
};

export default de;
